// extracted by css-extract-rspack-plugin
export default {"container":"NotificationContainer-module__container___qrjC1"};